import { useTranslation } from 'react-i18next';
// ----------------------------------------------------------------------
const langComparison = {
  zh: 'zh',
  english: 'en',
  cn: 'cn',
};

export default function useLocales() {
  const { i18n } = useTranslation();
  const language = langComparison[i18n.language];
  return {
    language,
  };
}
